import { AdaptiveSheet } from '../common/AdaptiveSheet';
import { PlanEventsPanel } from './PlanEventsPanel.web';

// Phone and tablet host for PlanEventsPanel. The desktop shell puts the same
// view in a CompanionPanel instead (DefensePlanPanel.web.tsx branches on
// useDesktopShell()), the way it does for plan updates.
export function PlanEventsSheet({
  visible,
  planId,
  bundleId,
  onClose,
}: {
  visible: boolean;
  planId: string | null;
  bundleId: string | null;
  onClose: () => void;
}) {
  return (
    <AdaptiveSheet isOpen={visible} onRequestClose={onClose} onDismiss={onClose} dialogWidth={480}>
      <AdaptiveSheet.ScrollView testID="plan-events-sheet">
        {planId && bundleId ? <PlanEventsPanel planId={planId} bundleId={bundleId} /> : null}
      </AdaptiveSheet.ScrollView>
    </AdaptiveSheet>
  );
}
